import { Box, Typography } from '@mui/material';

const stats = [
  {
    number: '10x+',
    label: 'Creative volume',
    sub: 'vs. founder-only or agency-supplied baselines',
  },
  {
    number: '2x',
    label: 'Creator count',
    sub: 'in your active program',
  },
  {
    number: 'Up to 15%',
    label: 'Lower blended CPI',
    sub: 'vs. your paid-ads-only benchmark · typical, not guaranteed',
  },
];

const LPSectionBlogs = () => {
  return (
    <div className="mb-12" id="benchmarks">
      {/* Section header */}
      <div className="flex flex-col items-center pt-14 mb-[60px] text-center gap-3">
        <p className="text-[12px] font-semibold tracking-[2.5px] uppercase text-[#0CAECF]">
          Benchmarks — not promises
        </p>
        <h2 className="text-[34.84px] leading-[100%] font-semibold text-center align-middle text-[#FFFFFF] font-inter">
          What our playbook typically produces.
        </h2>
        <p className="text-[16px] text-[#C0C0C0] font-inter font-light max-w-xl">
          Honestly framed. We&apos;ll talk through your specific targets on the discovery call.
        </p>
      </div>

      {/* Stat cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {stats.map(({ number, label, sub }) => (
          <Box
            key={label}
            sx={{
              border: '1px solid rgba(12, 174, 207, 0.3)',
              background: 'linear-gradient(139.56deg, rgba(12,174,207,0.08) -29.1%, rgba(88,15,107,0.08) 96.45%)',
              borderRadius: '12px',
              p: 4,
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              gap: 1
            }}
          >
            <Typography
              fontFamily="Inter"
              sx={{ fontSize: '52px', fontWeight: 800, color: '#FFFFFF', lineHeight: 1 }}
            >
              {number}
            </Typography>
            <Typography fontFamily="Inter" sx={{ fontSize: '16px', fontWeight: 600, color: '#FFFFFF' }}>
              {label}
            </Typography>
            <Typography fontFamily="Inter" sx={{ fontSize: '13px', color: '#808080' }}>
              {sub}
            </Typography>
          </Box>
        ))}
      </div>

      {/* Live in 30 days callout */}
      <Box
        sx={{
          border: '1px solid rgba(12, 174, 207, 0.2)',
          background: 'rgba(12,174,207,0.06)',
          borderRadius: '12px',
          p: 3,
          textAlign: 'center'
        }}
      >
        <Typography fontFamily="Inter" sx={{ fontSize: '20px', fontWeight: 600, color: '#FFFFFF', mb: 0.5 }}>
          Live in 15 days
        </Typography>
        <Typography fontFamily="Inter" sx={{ fontSize: '14px', color: '#808080' }}>
          vs. 6–9 months to build the same function in-house
        </Typography>
      </Box>
    </div>
  );
};

export default LPSectionBlogs;
